var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tableBtn"},[_c('b-button',{attrs:{"id":"deleteBtn","pill":"","size":"sm"},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_c('i',{staticClass:"bi bi-trash-fill icon deleteBtnIcon"})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }